import React from "react";
import { getInspectionCycleStatusList } from "../../helpers/backend_helper";
import MasterList from "./MasterList";

const InspectionCycleStatus = () => (
  <MasterList
    label="Inspection Cycle Status"
    pluralLabel="Inspection Cycle Statuses"
    listMasters={getInspectionCycleStatusList}
    fileName="inspection-cycle-statuses"
  />
);

export default InspectionCycleStatus;
